// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import packageJson from '../package.json'
console.info(
    '%c ynso-pro-english ' + packageJson.version,
    'background: #5b60c8; color: #fff'
)

//fix ios :action 無效問題
document.body.addEventListener('touchstart', function () {})

import Vue from 'vue'
import VModal from 'vue-js-modal'
import App from './App'
import router from './router'
import store from './store'
import Btn from '@/components/Btn.vue'
import Head from '@/components/Head.vue'
import Til from '@/components/Til.vue'
import Vue2TouchEvents from 'vue2-touch-events'
import VueI18n from 'vue-i18n'
import tw from '@/lang/zh_TW'
import {
    getNowTime
} from '@/plugin/tools'
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'tw',
    messages: {
        tw
    }
})

Vue.config.productionTip = false

Vue.use(Vue2TouchEvents, {
    disableClick: false,
    touchClass: 'active',
    tapTolerance: 10,
    swipeTolerance: 30,
    longTapTimeInterval: 400
})
Vue.use(VModal, {
    dialog: true
})

Vue.component('Btn', Btn)
Vue.component('Head', Head)
Vue.component('Til', Til)
let tmpWord = null
let tmpExamMeta = null
router.beforeEach((to, from, next) => {
    //登入檢查
    if (store.state.loginData || to.name === 'login') {
        switch (from.name) {
            case 'login':
                vm.$store.commit('setMenuOpen', true)
                break
            case 'main':
                vm.$store.commit('lessonExamListIndex', -1)
                break
            case 'word':
                tmpWord = vm.$store.state.word
                vm.$store.commit('word', null)
                break
            case 'examend':
                tmpExamMeta = vm.$store.state.examEndMata
                vm.$store.commit('examEndMata', null)
                break
            case 'exam':
                clearInterval(vm.$store.state.exam.timerId)
                break
        }
        switch (to.name) {
            case 'main':
                vm.$store.dispatch('getTodayVocabulary')
                vm.$store.dispatch('getMyNote')
                vm.$store.commit('today/todayStep', 0)
                break
            case 'myclass':
                vm.$store.dispatch('getMyLessons')
                break
            case 'myclasslist':
                vm.$store.dispatch('getVocabularyByLessonId', to.params.id)
                break
            case 'mynote':
                vm.$store.dispatch('getMyNote')
                break
            case 'today-exam':
                vm.$store.dispatch('getLessonExam')
                break
            case 'mytest':
                vm.$store.dispatch('getMyLessons')
                break
            case 'exam':
                vm.$store.dispatch('getLessonExamById', to.params.id)
                break
            case 'mydoc':
                vm.$store.commit('calendar/calendarRest')
                break
            case 'word':
                vm.$store.state.word ? '' : vm.$store.commit('word', tmpWord)
                break
            case 'exercise': //某日的單字練習
                if (!vm.$store.state.selectDate) return
                vm.$store.dispatch(
                    'getTodayVocabulary',
                    vm.$store.state.selectDate
                )
                vm.$store.dispatch('getMyNote')
                break
            case 'test': //某日的單字測驗
                if (!vm.$store.state.selectDate) return
                vm.$store.dispatch('getLessonExam', vm.$store.state.selectDate)
                break
        }
        next()
    } else {
        next({
            name: 'login'
        })
    }
})
router.replace({
    path: '*',
    redirect: {
        name: 'login'
    }
})
/* eslint-disable no-new */
const vm = new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>',
    i18n
})

onResize()
window.addEventListener('resize', onResize)

function onResize() {
    vm.$store.commit('setStageWw', window.innerWidth)
}



// WEBPACK FOOTER //
// ./src/main.js